import Card from "../../Components/Card/Card";
import React, { useEffect, useState } from "react";
import Content from "../../Components/Content/Content";
import { Switch, message } from "antd";
import { BsPersonFillGear } from "react-icons/bs";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import styles from "./Settings.module.scss";
import SettingsFunction from "../../Functions/Settings/Settings";
import { useDispatch } from "react-redux";
import { setCustomer } from "../../Redux/Customer/customerSlice";
import { MdMail } from "react-icons/md";
import { IconType } from "react-icons";

const Settings: React.FC = () => {
  const accessToken = useSelector(
    (state: RootState) => state.access.accessToken
  );
  const custId = useSelector((state: RootState) => state.user.user?.custID);
  const sessionToken = useSelector((state: RootState) => state.user.token);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const customer = useSelector((state: RootState) => state.customer);



  const [autoMailFeatureEnabled, setAutoMailFeatureEnabled] = useState(customer.autoMailEnabled);

  const handleToggle = () => {
    setLoading(true);
    SettingsFunction.toggleAutoMailFeature(accessToken!, sessionToken!, custId)
      .then((response: any) => {
        if (response.status) {
          message.success("Auto mail feature updated successfully");
          setAutoMailFeatureEnabled(!autoMailFeatureEnabled);
          dispatch(setCustomer(response.data.customer));
        } else {
          message.error("Failed to update auto mail feature");
        }
      })
      .catch((error: any) => {
        message.error("Failed to update auto mail feature");
      }).finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setAutoMailFeatureEnabled(customer.autoMailEnabled);
  }, [customer]);

  const Subheader = (text: string, Icon: IconType, id: string) => {
    return (
      <div className={`d-flex ${styles.subheaderWrapper}`} id={id}>
        <div className={"mb-1 mx-1"}>
          <Icon color={"#ff6347"} size={15} />
        </div>
        <div className={`${styles.subheader}`}>{text}</div>
        <hr className={`w-100 ${styles.subheaderDevider}`} />
      </div>
    );
  };

  return (
    <>
        <Content>
        <div className="p-0 d-flex justify-content-center align-items-start ">
          <div className={`container mt-3 anchor-container`}>
            <div className={"row pt-5 pb-5"}>
              <div className={"col-sm col-md-12 col-lg-12"}>
                <Card
                  id={"userSettings"}
                  width={"100%"}
                  image={BsPersonFillGear}
                  header={`Change User Settings ${customer?.name ? ("- " + customer?.name) : ''}`}
                >
                  {customer?.name ? (
                    <>
                      {Subheader(
                        "UCaaS:",
                        MdMail,
                        "other-options"
                      )}
                      <div className="d-flex justify-content-center align-items-center pb-5">
                        <span className={styles.label}>
                          Enable Automatic Sending of Credential Emails:
                        </span>
                        <Switch
                          className={styles.switch}
                          checked={autoMailFeatureEnabled}
                          onChange={handleToggle}
                          disabled={loading}
                          loading={loading}
                          style={{ marginLeft: "10px" }}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">
                      <span className={styles.label}>
                        No customer selected
                      </span>
                    </div>
                  )}
                </Card>
              </div>
            </div>
          </div>
        </div>
      </Content>
    </>
  );
};

export default Settings;
